import { apiClient } from '@/services/apiClient'
import type {
  ApiResponse,
  Restaurant,
  MenuCategory,
  RestaurantListItem,
  PartnerSignupRequest,
} from '@/interfaces'

export const restaurantApi = {
  async getRestaurantData(
    tenantId: string,
    params: Record<string, any> = {}
  ): Promise<ApiResponse<Restaurant>> {
    const response = await apiClient.get(`restaurant/guest/show/${tenantId}`, { params })
    return response.data
  },

  async getMenuCategoryArray(
    tenantId: string,
    params: Record<string, any> = {}
  ): Promise<ApiResponse<MenuCategory[]>> {
    const response = await apiClient.get(`menu_category/guest/tree/${tenantId}`, {
      params,
    })
    return response.data
  },

  async filterMenuItems(params: {
    tenant_id: string
    meal_type: number | string
    searchParam?: string
    category_visibility?: Array<string>
  }): Promise<ApiResponse<MenuCategory[]>> {
    const response = await apiClient.post(
      `restaurant/guest/filter_menu_items/${params.tenant_id}/${params.meal_type}`,
      params
    )
    return response.data
  },

  /**
   * POST customer/check_table_availability
   * Payload: { table_no, tenant_id } (e.g. table_no: "Restaurant-5", tenant_id: "DUTCHTRAILS")
   * Response: true = table available (no banner), false = table received/booked (show banner)
   */
  async checkTableAvailability(params: {
    tenant_id: string
    table_no: string
  }): Promise<ApiResponse<boolean | { show_table_available: boolean }>> {
    const response = await apiClient.post('customer/check_table_availability', params)
    return response.data
  },

  async getAllRestaurants(params: {
    page: number
    search_city?: string
    search_restaurant?: string
    search_service_station?: string
    search_cuisines_type?: string
  }): Promise<ApiResponse<{ data: RestaurantListItem[]; links: Array<{ url: string }> }>> {
    const response = await apiClient.post(`restaurant/guest/all?page=${params.page}`, params)
    return response.data
  },

  async signupRestaurantRequest(data: PartnerSignupRequest): Promise<ApiResponse> {
    const formData = new FormData()
    formData.append('restaurant_name', data.restaurant_name)
    formData.append('first_name_cp', data.first_name_cp)
    formData.append('last_name_cp', data.last_name_cp)
    formData.append('mobile_no', data.mobile_no)
    formData.append('email', data.email)
    formData.append('restaurant_contact_no', data.restaurant_contact_no || data.mobile_no)

    const response = await apiClient.post('restaurant/signup/create', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  },
}
